/* eslint-disable react/no-array-index-key */
import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { NSBadge } from '..';
import RenderIf from '../../components/RenderIf/RenderIf';

export interface IProps {
    badgeItems: string[];
    id: string;
    containerClassName?: string;
    maxDisplayedItems?: number;
}

const NSBadgeList = ({
    badgeItems, id, containerClassName, maxDisplayedItems,
}: IProps) => {
    const itemIndex = maxDisplayedItems || badgeItems.length;
    const displayedBadgeItems = badgeItems.slice(0, itemIndex);
    const tooltipBadgeItems = badgeItems.slice(itemIndex);

    return (
        <div id={id} className={containerClassName || 'd-inline-block'}>
            <RenderIf isTrue={!badgeItems.length}>
                <NSBadge>&mdash;</NSBadge>
            </RenderIf>

            <RenderIf isTrue={displayedBadgeItems.length}>
                {displayedBadgeItems.map((item, index) => (
                    <NSBadge key={`${id}-displayed-badge-item-${index}`} className="mr-1">
                        {item}
                    </NSBadge>
                ))}
            </RenderIf>

            <RenderIf isTrue={tooltipBadgeItems.length}>
                <NSBadge>...</NSBadge>

                <UncontrolledTooltip target={id} style={{ maxWidth: '450px' }}>
                    {tooltipBadgeItems.map((item, index) => (
                        <NSBadge key={`${id}-tooltip-badge-item-${index}`} className="mr-1">
                            {item}
                        </NSBadge>
                    ))}
                </UncontrolledTooltip>
            </RenderIf>
        </div>
    );
};

export default NSBadgeList;
